import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetNotificationCountQueryVariables = Types.Exact<{
  receiver_id: Types.Scalars['String']['input'];
}>;


export type GetNotificationCountQuery = { __typename?: 'query_root', notifications_aggregate: { __typename?: 'notifications_aggregate', aggregate?: { __typename?: 'notifications_aggregate_fields', count: number } | null } };


export const GetNotificationCountDocument = gql`
    query getNotificationCount($receiver_id: String!) {
  notifications_aggregate(
    where: {receiver_id: {_eq: $receiver_id}, archived: {_eq: false}, viewed: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetNotificationCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationCountQuery({
 *   variables: {
 *      receiver_id: // value for 'receiver_id'
 *   },
 * });
 */
export function useGetNotificationCountQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationCountQuery, GetNotificationCountQueryVariables> & ({ variables: GetNotificationCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationCountQuery, GetNotificationCountQueryVariables>(GetNotificationCountDocument, options);
      }
export function useGetNotificationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationCountQuery, GetNotificationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationCountQuery, GetNotificationCountQueryVariables>(GetNotificationCountDocument, options);
        }
export function useGetNotificationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationCountQuery, GetNotificationCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationCountQuery, GetNotificationCountQueryVariables>(GetNotificationCountDocument, options);
        }
export type GetNotificationCountQueryHookResult = ReturnType<typeof useGetNotificationCountQuery>;
export type GetNotificationCountLazyQueryHookResult = ReturnType<typeof useGetNotificationCountLazyQuery>;
export type GetNotificationCountSuspenseQueryHookResult = ReturnType<typeof useGetNotificationCountSuspenseQuery>;
export type GetNotificationCountQueryResult = Apollo.QueryResult<GetNotificationCountQuery, GetNotificationCountQueryVariables>;